import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as documentSelector } from 'ducks/inventoryEnquiry/attachments/documents';
import { fetch } from 'api/inventoryEnquiry/attachments/documents';
import { actions as filterActions, selectors as filterSelectors } from 'ducks/common/filters';
import { selectors as inventoryProductSelector } from 'ducks/inventoryEnquiry/inventoryProduct';
import { IApplicationState } from 'ducks/reducers';

const getParams = () => new URLSearchParams(location.search);

export const mapStateToProps = (state: IApplicationState) => ({
  gridName: 'InventoryEnquiryDocuments',
  columnDefs: documentSelector.columns(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
  gridOptions: documentSelector.gridOptions(state),
  filterRow: documentSelector.filterRow(state),
  selectedFilters: documentSelector.selectedFilters(state),
  appliedFilters: documentSelector.filterRow(state) && filterSelectors.getFilters(state, documentSelector.filterRow(state).formName),
  reqParams: (inventoryProductSelector.selected(state) || getParams().get('ProductId'))
    &&
  {
    ProductId: (inventoryProductSelector.selected(state) && inventoryProductSelector.selected(state).ProductId) || getParams().get('ProductId')
  },
  apiMethod: fetch
});

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  applyFilters: filterActions.applyFilters
};
